import React from 'react';
import ColorTag from '../ColorTag/ColorTag';

interface ColorTagParentProps {}

const ColorTagParent: React.FC<ColorTagParentProps> = props => {
  return <ColorTag className="ColorTagParent" color="firebrick">Parent</ColorTag>
}

export default ColorTagParent;